import React, {Component} from 'react';
import PropTypes from 'prop-types';
import media from '../MediaQueries.js';
import styled from 'styled-components';
import Connect from '../components/Connect.js';
import { SocialIcon } from 'react-social-icons';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';

export default class Footer extends Component {
  //static propTypes = {testProp: PropTypes.bool.isRequired}

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    //const ExampleObject = ( <div></div> );

    return (
      <FluidContainer  fluid>
        <InternalContainer>

          <Row>
            <LeftCol xs="12" md="4">
              <div>
                <h3>Contact Us</h3>
                    <LocationInfoDiv>
                    <p>M-F: 10AM to 5PM</p>
                    <p style={{marginBottom: "15px"}}>Sat: 9AM to 3PM</p>

                    <p>119 Patterson Road</p>
                    <p>Westfield, PA 16950</p>
                    <p>(814)-628-3751</p>
                    <a target="_blank" href="https://www.google.com/maps/place/Patterson+Maple+Farms/@41.8474617,-77.5351781,18z/data=!3m1!4b1!4m5!3m4!1s0x89ce20414219c9bb:0x99fe70447a64bc64!8m2!3d41.8474601!4d-77.5343149">
                      Google Maps Directions</a>
                    <FacebookDiv>
                        {/*<img src={require("../media/facebook.jpg")}></img>*/}
                        <SocialIcon_Facebook target="_blank" network="facebook" url="https://www.facebook.com/Patterson-Farms-264986307007350/" color="black" />
                      <a style={{marginTop: "5px"}} target="_blank" href="https://www.facebook.com/Patterson-Farms-264986307007350/">Follow us on Facebook ></a>
                    </FacebookDiv>
                  </LocationInfoDiv>
              </div>
            </LeftCol>

            <MiddleCol xs="12" md="4">
              
              <div>
              <h3>Our Goal</h3>
              <p>
                We take pride in producing the finest quality maple syrup, cream, candy, sugar, gift baskets, and much more, all for those
                who enjoy the pure taste of nature's premium sweetness.
              </p>
              </div>
            </MiddleCol>

            <RightCol xs="12" md="4">
              <div>
                <Connect />
              </div>
            </RightCol>
          </Row>

        </InternalContainer>

        <BottomLinkAndDesignedByContainer_Fluid fluid>
          <BottomLinkAndDesignedByContainer>
            <Row>
              <Col xs="12" md="8" lg="7" >
                <Link to="/Privacy">Privacy</Link>
                {' / '}
                <Link to="/Terms">Terms</Link>
                {' / '}
                <Link to="/RefundsCancellations">Refunds</Link>
                {' / '}
                <Link to="/Sitemap">Sitemap</Link> 
                {' / '}
                <Link to="/Storage">Storage</Link>
                {' / '}
                <Link to="/FAQ">FAQ</Link>
                {' / '}
                <Link to="/Contact">Contact</Link>
              </Col>
              <Col xs="12" md="4" lg="5">
                <p> Patterson Farms &copy;{new Date().getFullYear()}. All Rights Reserved. </p>
              </Col>
              <Col xs="12" md="12" lg="12">
                <DesignedByA href="https://www.lotus29.com" target="_blank">Website designed by Lotus29</DesignedByA>
              </Col>
            </Row>
          </BottomLinkAndDesignedByContainer>
        </BottomLinkAndDesignedByContainer_Fluid>
      </FluidContainer>
    );
  }
}

const SocialIcon_Facebook = styled(SocialIcon)`
  transition-duration: 0.3s;
  transition-property: background-color, box-shadow, border, color, opacity, transform;
  transition-timing-function: ease-in-out;
  margin-right: 12px;
  
  :hover {
    .social-svg-mask {
      fill: rgb(59, 89, 152)!important;
    }
  }
`;

const FacebookDiv = styled.div`
  margin-top: 10px;

  img {
    height: 35px;
    width: 35px;
    margin-right: 5px;
  }
`;

const BottomLinkAndDesignedByContainer_Fluid = styled(Container)` 
  background-color: white; 
`;

const BottomLinkAndDesignedByContainer = styled(Container)` 
  padding: 20px 0 0 0;
  font-size: 11px!important;
  ${media.sm` font-size: 14px!important; `}
  ${media.lg` font-size: 15px!important; `}

  p { margin-bottom: 0; }

  .col-12 {  
    padding: 0; margin-bottom: 10px; 

    p { ${media.md`text-align: right;`} }

    a, p {
      font-size: 11px!important;
      ${media.sm` font-size: 14px!important; `}
      ${media.lg` font-size: 15px!important; `}
    }

  }
`;

const InternalContainer = styled(Container)`
  padding-bottom: 0px;

  .col-12 {  margin-bottom: 20px; }

  h3 { 
    margin-bottom: 12px; color: black!important; 
    ${media.md`  margin-bottom: 30px; `}
  }
`;

const FluidContainer = styled(Container)`
  padding: 40px 0 0 0!important;
  background-color: #e69900;

  a, p {
    font-size: 16px!important;
    ${media.md` font-size: 18px!important; `}
  }
`;

const LocationInfoDiv = styled.div`
  p { margin-bottom: 0; }
`;

const DesignedByA = styled.a`
  ${media.md` float: right; `}
`;



const LeftCol = styled(Col)`

`;

const MiddleCol = styled(Col)`
  p {
    margin: 0;

    ${media.md`margin: 0 0 24px 0;`}
  }
`;

const RightCol = styled(Col)`

`;







//const Div_s = styled.div``;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/


// WEBPACK FOOTER //
// ./src/components/Footer.js